export default __webpack_public_path__ + "static/About-us-giving-mobile-77d697df31e64309c6e6abedb1317b61.png";